(function () {
  // Owner-reported 2026-08-09 — Flutter's ProductOptionChoiceChip row is a
  // draggable carousel; the web variant rail scrolled natively on touch but
  // had no mouse-drag support on desktop (overflow-x:auto alone only
  // responds to a trackpad/wheel/scrollbar, not a click-drag gesture).
  // Adds pointer-drag-to-scroll for mouse pointers only — touch keeps its
  // native momentum scroll, unaffected.
  var DRAG_THRESHOLD = 6;

  // Owner-reported 2026-08-09 — selecting a variant (e.g. clicking a
  // variant-image swatch) can select an option whose chip sits scrolled
  // out of the row's visible area, leaving the customer unable to see
  // which variant name is now active. Scroll that chip into view.
  // Hooked into bindRow below rather than Prestige's `variant:change`
  // event: that event fires the instant selectCombination() is called,
  // well before the async fetch()+innerHTML swap it kicks off actually
  // lands (confirmed live — a fixed setTimeout after variant:change
  // raced that swap and got clobbered by it). bindRow only runs on a
  // freshly-inserted row (its own dataset guard), which the MutationObserver
  // below only sees once product:rerender's swap has actually landed —
  // a real signal instead of a guessed delay.
  function scrollSelectedIntoView(row) {
    var selected = row.querySelector(':checked + .block-swatch, .block-swatch.is-selected');
    if (!selected) return;
    var rowRect = row.getBoundingClientRect();
    var selRect = selected.getBoundingClientRect();
    if (selRect.left >= rowRect.left - 0.5 && selRect.right <= rowRect.right + 0.5) return;
    // 'center' rather than 'nearest' — 'nearest' left a partial-overflow
    // gap in testing (the desktop scroll-arrow buttons overlay the row's
    // own edges, so "just barely at the row's boundary" can still sit
    // behind an arrow); centering leaves comfortable margin either side.
    // 'instant', not 'smooth' — confirmed live that a smooth scroll here
    // gets interrupted/reset before completing.
    selected.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'instant' });
  }

  function bindRow(row) {
    if (row.dataset.erosDragBound) return;
    row.dataset.erosDragBound = '1';
    scrollSelectedIntoView(row);

    var dragging = false;
    var moved = false;
    var startX = 0;
    var startScrollLeft = 0;

    row.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startScrollLeft = row.scrollLeft;
      row.classList.add('is-dragging');
    });

    row.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var dx = event.clientX - startX;
      if (Math.abs(dx) > DRAG_THRESHOLD) moved = true;
      if (!moved) return;
      event.preventDefault();
      row.scrollLeft = startScrollLeft - dx;
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      row.classList.remove('is-dragging');
      // Suppress the click that fires right after a real drag, so releasing
      // the mouse over a swatch mid-drag doesn't also select it.
      if (moved) {
        var suppressClick = function (clickEvent) {
          clickEvent.preventDefault();
          clickEvent.stopPropagation();
          row.removeEventListener('click', suppressClick, true);
        };
        row.addEventListener('click', suppressClick, true);
        window.setTimeout(function () {
          row.removeEventListener('click', suppressClick, true);
        }, 0);
      }
      moved = false;
    }

    row.addEventListener('pointerup', endDrag);
    row.addEventListener('pointercancel', endDrag);
    row.addEventListener('pointerleave', function () {
      if (dragging) endDrag();
    });
  }

  var SCROLL_STEP = 160;

  function bindArrows(wrap) {
    if (wrap.dataset.erosArrowsBound) return;
    wrap.dataset.erosArrowsBound = '1';

    var row = wrap.querySelector('.variant-picker__option-values');
    var prevBtn = wrap.querySelector("[data-eros-variant-scroll='prev']");
    var nextBtn = wrap.querySelector("[data-eros-variant-scroll='next']");
    if (!row || !prevBtn || !nextBtn) return;

    // Storefront is RTL (Arabic). Per the CSSOM View spec (Chrome/Firefox/
    // Safari all follow this now), an RTL overflow container's scrollLeft
    // starts at 0 ("start"/rightmost) and goes NEGATIVE toward -maxScroll
    // as you scroll further into the row — not 0..+maxScroll like LTR.
    // "prev"/"next" here mean reading-order back/forward, not left/right.
    var isRtl = getComputedStyle(row).direction === 'rtl';
    var stepSign = isRtl ? -1 : 1;

    function update() {
      var maxScroll = row.scrollWidth - row.clientWidth;
      var hasOverflow = maxScroll > 1;
      if (!hasOverflow) {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        return;
      }
      if (isRtl) {
        prevBtn.hidden = row.scrollLeft >= -1;
        nextBtn.hidden = row.scrollLeft <= -maxScroll + 1;
      } else {
        prevBtn.hidden = row.scrollLeft <= 1;
        nextBtn.hidden = row.scrollLeft >= maxScroll - 1;
      }
    }

    prevBtn.addEventListener('click', function () {
      row.scrollBy({ left: -SCROLL_STEP * stepSign, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      row.scrollBy({ left: SCROLL_STEP * stepSign, behavior: 'smooth' });
    });

    row.addEventListener('scroll', update);
    window.addEventListener('resize', update);

    // Swatch widths settle after webfonts/layout; a couple of deferred
    // passes catch overflow that isn't measurable on the very first tick.
    update();
    window.requestAnimationFrame(update);
    window.setTimeout(update, 300);
  }

  function bindAll(root) {
    var scope = root || document;
    scope
      .querySelectorAll(
        ".product-info__block-item[data-block-type='variant-picker'] .variant-picker__option-values"
      )
      .forEach(bindRow);
    scope
      .querySelectorAll(
        ".product-info__block-item[data-block-type='variant-picker'] .eros-variant-scroll-wrap"
      )
      .forEach(bindArrows);
  }

  // PERF (2026-09-09): the initial bind used to run synchronously at script
  // execution — scrollSelectedIntoView() (two getBoundingClientRect) and
  // update() (scrollWidth/clientWidth ×3) read layout while the page had not
  // painted yet, forcing full-page synchronous layouts on the critical path.
  // Lighthouse attributed 343 ms of forced reflow to this file on the PDP
  // (the largest first-party culprit). Everything here is an enhancement
  // (mouse drag-to-scroll, arrows, centring the selected chip), so it now
  // binds on idle after first paint — layout is clean by then, so the same
  // reads are free — with a bounded fallback so it is never late for a tap.
  function idle(fn, timeout) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: timeout });
    else window.setTimeout(fn, Math.min(timeout, 500));
  }
  idle(function () { bindAll(); }, 1500);

  // Variant swaps (Prestige re-renders <variant-picker> on selection) and
  // the quick-buy sheet opening both introduce new rows after initial load.
  // Coalesced to one bindAll per frame: during load, many unrelated scripts
  // insert nodes (toasts, drawers, badges), and re-binding on every mutation
  // re-read layout each time.
  var rebindScheduled = false;
  var observer = new MutationObserver(function (mutations) {
    if (rebindScheduled) return;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        rebindScheduled = true;
        window.requestAnimationFrame(function () {
          rebindScheduled = false;
          bindAll();
        });
        return;
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
